import { toggled } from "../actions";

const updateToggle = (status, todoId) => {
  return async (dispatch) => {
    const response = await fetch(
      `https://lwsumit.herokuapp.com/todos/${todoId}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          completed: !status,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8 ",
        },
      }
    );
    const todo = await response.json();
    dispatch(toggled(todo.id));
  };
};

export default updateToggle;
